/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetEvidence200ResponseWarnings
 */
export interface GetEvidence200ResponseWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseWarnings
     */
    'detectedDpi'?: GetEvidence200ResponseWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseWarnings
     */
    'calculatedDpi'?: GetEvidence200ResponseWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseWarnings
     */
    'colorGradation'?: GetEvidence200ResponseWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseWarnings
     */
    'heightMillis'?: GetEvidence200ResponseWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidence200ResponseWarnings
     */
    'widthMillis'?: GetEvidence200ResponseWarningsWidthMillisEnum;
}

export const GetEvidence200ResponseWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidence200ResponseWarningsDetectedDpiEnum = typeof GetEvidence200ResponseWarningsDetectedDpiEnum[keyof typeof GetEvidence200ResponseWarningsDetectedDpiEnum];
export const GetEvidence200ResponseWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidence200ResponseWarningsCalculatedDpiEnum = typeof GetEvidence200ResponseWarningsCalculatedDpiEnum[keyof typeof GetEvidence200ResponseWarningsCalculatedDpiEnum];
export const GetEvidence200ResponseWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidence200ResponseWarningsColorGradationEnum = typeof GetEvidence200ResponseWarningsColorGradationEnum[keyof typeof GetEvidence200ResponseWarningsColorGradationEnum];
export const GetEvidence200ResponseWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidence200ResponseWarningsHeightMillisEnum = typeof GetEvidence200ResponseWarningsHeightMillisEnum[keyof typeof GetEvidence200ResponseWarningsHeightMillisEnum];
export const GetEvidence200ResponseWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidence200ResponseWarningsWidthMillisEnum = typeof GetEvidence200ResponseWarningsWidthMillisEnum[keyof typeof GetEvidence200ResponseWarningsWidthMillisEnum];


